import React, { memo, useState } from "react";
import { Tooltip } from "antd";
import { Badge } from "reactstrap";
import ModalPanel from "./PanelModal";
import { gql, useMutation } from "@apollo/client";
import moment from "moment-jalaali";
import dayjs from "dayjs";

dayjs.calendar("jalali");

const GET_OPTIMIZER = gql`
  mutation Optimizer($PO_id: Int!, $date: [Date], $offset_date: Int) {
    GetOptimizerData(PO_id: $PO_id, date: $date, offset_date: $offset_date) {
      PO_id
      serial_number
      Opt_Group_id
      batch_number
      model
      production {
        Ipv
        Ibat
        Vbat
        Vpv
        Vo
        SOC
        Temp
        date_time
      }
      events {
        events {
          Event_Description {
            event_code
            title
            content
          }
          event_code
          event_time
          PO_id
          description
        }
        count
      }
    }
  }
`;

// تابع کمکی برای تبدیل تاریخ به فرمت میلادی
const formatDateForAPI = (dateInput) => {
  if (!dateInput) return "";
  
  console.log("formatDateForAPI input:", dateInput);
  
  try {
    // اگر moment object است (از jalali-moment)
    if (dateInput._isAMomentObject) {
      return dateInput.format("YYYY-MM-DD");
    }
    
    // اگر dayjs object است
    if (dateInput.$isDayjsObject) {
      return dayjs(dateInput).format("YYYY-MM-DD");
    }
    
    // اگر Date object است
    if (dateInput instanceof Date) {
      return moment(dateInput).format("YYYY-MM-DD");
    }
    
    // اگر string است
    if (typeof dateInput === 'string') {
      // اگر رشته شمسی است (سال 4 رقمی کمتر از 1500)
      if (dateInput.includes('-')) {
        const yearPart = dateInput.split('-')[0];
        if (yearPart.length === 4 && parseInt(yearPart) < 1500) {
          return moment(dateInput, 'jYYYY-jMM-jDD').format("YYYY-MM-DD");
        }
      }
      
      // اگر رشته میلادی است
      return dateInput;
    }
  } catch (error) {
    console.error("Error in formatDateForAPI:", error);
  }
  
  // پیش‌فرض: امروز
  return moment().format("YYYY-MM-DD");
};

const Pannel = ({
  optimizer,
  index,
  length,
  lang_choiced,
  DataGetStatus,
  dateHOC,
  setDateHOC,
  editMode,
  blockIndex = 0,
  panelsPerRow = 10,
  group_index
}) => {
  const [showModal, setShowModal] = useState(false);
  const [powerOptimizer, setPowerOptimizer] = useState();
  const [dailyChartData, setDailyChartData] = useState([]);
  const [sliderChartData, setSliderChartData] = useState();
  const [events, setEvents] = useState();
  const [count, setCount] = useState(0);
  const [loadingDailyChart, setLoadingDailyChart] = useState(true);

  console.log("Pannel received dateHOC:", dateHOC);

  const [getOptimizer] = useMutation(GET_OPTIMIZER, {
    onCompleted: (res) => {
      const {
        production,
        serial_number,
        Opt_Group_id,
        batch_number,
        model,
        PO_id,
        events,
      } = res.GetOptimizerData;
      setPowerOptimizer({
        serial_number,
        Opt_Group_id,
        batch_number,
        model,
        PO_id,
      });
      setEvents(events.events);
      setCount(events.count);

      const createChartData = (productions) => {
        return productions.map((product) => {
          let newDate = new Date(parseInt(product.date_time));
          let dateChart = new Date(
            moment(newDate).format("jYYYY-jMM-jDDTHH:mm:ss")
          );
          return {
            product: product.Vpv * product.Ipv,
            product_bat: product.Ibat * product.Vbat,
            date: dateChart,
            V: product.Vpv,
            I: product.Ipv,
            Vo: product.Vo,
            Ibat: product.Ibat,
            Vbat: product.Vbat,
            SOC: product.SOC,
            Temp: Math.round(product.Temp / 10) / 10,
          };
        });
      };

      setLoadingDailyChart(false);
      setDailyChartData(createChartData(production, false));
    },
    onError: () => {
      setDailyChartData([]);
      setLoadingDailyChart(false);
    },
  });

  const handleDateChange = (date) => {
    // date باید آرایه‌ای از moment objectها یا stringها باشد
    const formattedDate = [
      formatDateForAPI(date[0]),
      formatDateForAPI(date[1])
    ];
    
    console.log("handleDateChange formatted:", formattedDate);
    
    getOptimizer({
      variables: {
        PO_id: optimizer.PO_id,
        date: formattedDate,
        offset_date: new Date().getTimezoneOffset(),
      },
    });
    setLoadingDailyChart(true);
  };

  const checkProductionTime = (prod) => {
    const static_date = new Date();
    static_date.setMinutes(static_date.getMinutes() - 10);
    const int_static_date = static_date.getTime();
    if (int_static_date < prod?.date_time && prod?.date_time) {
      return prod;
    } else {
      return null;
    }
  };

  const checkProductionCalibration = (production) => {
    const power = (production?.Vpv / 100) * (production?.Ipv / 1000);
    return power > 5 ? power : 0;
  };

  const checkProductionConsumptionCalibration = (production) => {
    return production > 0 ? production : 0;
  };

  const production = checkProductionTime(optimizer.Last_Production[0]);

  const rowIndex = Math.floor(index / panelsPerRow) + 1;
  const colIndex = (index % panelsPerRow) + 1;
  const displayOrder = `${group_index}-${colIndex}`;

  return (
    <React.Fragment>
      <ModalPanel
        dateHOC={dateHOC}
        setDateHOC={(date) => {
          // date از RangePicker می‌آید که moment object است
          setDateHOC(date);
          handleDateChange(date);
        }}
        powerOptimizer={powerOptimizer}
        lastProduction={DataGetStatus ? production : []}
        serial_number={optimizer.serial_number}
        showModal={showModal}
        setShowModal={(value) => {
          setDailyChartData([]);
          setSliderChartData([]);
          setShowModal(value);
        }}
        dailyChartData={dailyChartData}
        sliderChartData={sliderChartData}
        events={events}
        count={count}
        key={`${index}_modal`}
        loadingDailyChart={loadingDailyChart}
        setRefresh={() => {
          const formattedDate = [
            formatDateForAPI(dateHOC[0]),
            formatDateForAPI(dateHOC[1])
          ];
          
          console.log("setRefresh formatted:", formattedDate);
          
          getOptimizer({
            variables: {
              PO_id: optimizer.PO_id,
              date: formattedDate,
              offset_date: new Date().getTimezoneOffset(),
            },
          });
          setLoadingDailyChart(true);
        }}
      />
      <Tooltip
        overlayStyle={{ borderRadius: "10px" }}
        placement="top"
        title={
          <div style={{ direction: "ltr" }} className="text-left">
            <p className="b-b-1-bypanel mb-1">
              S/N : {optimizer.serial_number}
            </p>
            <p className="b-b-1-bypanel m-0 text-left" style={{textAlignLast:"left !important"}}>
              V<sub>out</sub> :{" "}
              {DataGetStatus && production !== null
                ? (production.Vo / 10).toFixed(1)
                : "-"}{" "}
              v
            </p>
            <p className="b-b-1-bypanel m-0 text-left" style={{textAlignLast:"left !important"}}>
              P<sub>Solar Panel</sub> :{" "}
              {DataGetStatus && production !== null
                ? checkProductionCalibration(production).toFixed(0)
                : "-"}{" "}
              w
            </p>
            <p className="b-b-1-bypanel m-0 text-left" style={{textAlignLast:"left !important"}}>
              P<sub>Battery</sub> :{" "}
              {DataGetStatus && production !== null
                ? (
                    (production?.Vbat / 100) *
                    (production?.Ibat / 1000)
                  ).toFixed(0)
                : "-"}{" "}
              w
            </p>
            <p className="m-0 bold text-left" style={{textAlignLast:"left !important"}}>
              P<sub>Total</sub> :{" "}
              {DataGetStatus && production !== null
                ? Math.round(
                    checkProductionCalibration(production) +
                      ((Math.round(production?.Vbat) / 100) *
                        Math.round(production?.Ibat)) /
                        1000
                  )
                : "-"}{" "}
              W
            </p>
          </div>
        }
      >
        <div
          id={`by-solar-panel${index}`}
          className="by-solar-pannel text-center"
          onClick={() => {
            setShowModal(true);
            
            // تبدیل تاریخ‌ها به فرمت صحیح
            const formattedDate = [
              formatDateForAPI(dateHOC[0]),
              formatDateForAPI(dateHOC[1])
            ];
            
            console.log("onClick formatted:", formattedDate);
            
            getOptimizer({
              variables: {
                PO_id: optimizer.PO_id,
                date: formattedDate,
                offset_date: new Date().getTimezoneOffset(),
              },
            });
          }}
        >
          {/* بقیه کد بدون تغییر */}
          <div className="by-solar-panel text-center ltr" style={{ paddingTop: "12px" }}>
            <Badge
              style={{ fontSize: "16px" }}
              color={
                DataGetStatus && production !== null
                  ? checkProductionCalibration(production).toFixed(0) > 0
                    ? "success"
                    : "success"
                  : "secondary"
              }
            >
              {DataGetStatus && production !== null
                ? Math.round(checkProductionCalibration(production)) > 0
                  ? `${Math.round(checkProductionCalibration(production))} W`
                  : "0 W"
                : " - "}
            </Badge>

            <br />

            <Badge
              color=""
              className="battery-filler"
              style={{
                backgroundImage: !production?.SOC
                  ? `linear-gradient(to right, red 1%, #eeeeee 1%)`
                  : production?.SOC / 100 < 30
                  ? `linear-gradient(to right, red ${production?.SOC / 100}%, #eeeeee 1%)`
                  : production?.SOC / 100 < 50
                  ? `linear-gradient(to right, orange ${production?.SOC / 100}%, #eeeeee 1%)`
                  : `linear-gradient(to right, #52c41a ${production?.SOC / 100}%, #eeeeee 1%)`,
              }}
            >
              <p style={{ fontSize: "16px", marginTop: "5px" }}>
                {((production?.Vbat / 100) * (production?.Ibat / 1000)).toFixed(0) < -5
                  ? "⚡"
                  : ""}
                {DataGetStatus && production !== null
                  ? `${(production?.SOC / 100 > 100
                      ? 100
                      : production?.SOC / 100
                    ).toFixed(0)}%`
                  : "-"}
              </p>
            </Badge>

            <Badge className="power-consumption" color="default">
              {DataGetStatus && production !== null
                ? `${Math.round(
                    checkProductionConsumptionCalibration(
                      checkProductionCalibration(production) +
                        ((Math.round(production?.Vbat) / 100) *
                          Math.round(production?.Ibat)) /
                          1000
                    )
                  )} W`
                : "-"}{" "}
            </Badge>
          </div>

          <label>
            <b>{displayOrder}</b>
            <br />
            {editMode && (
              <b className="text-danger">{optimizer.serial_number}</b>
            )}
          </label>
        </div>
      </Tooltip>
    </React.Fragment>
  );
};

export default Pannel;